module.exports = __webpack_public_path__ + "static/wordpress7-ec871df765da578180c34c8bee38dfa5.png";